import React from 'react';

import PropTypes from 'prop-types';

import { TextActivityCard } from '@adsk/alloy-react-activity-log';
import { useLocale } from '@adsk/alloy-react-locale';

import { ACTIVITY_VARIANTS } from '../constants';

const DocsActivityCard = React.forwardRef(
  ({ entity, variant, ...rest }, ref) => {
    const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));
    return (
      <TextActivityCard
        {...rest}
        ref={ref}
        title={
          variant === ACTIVITY_VARIANTS.REMOVED
            ? T.translate('FILE_ACTIVITY_TITLE_REMOVED')
            : T.translate('FILE_ACTIVITY_TITLE_ADDED')
        }
        text={entity.name}
      />
    );
  },
);

DocsActivityCard.displayName = 'DocsActivityCard';

DocsActivityCard.propTypes = {
  variant: PropTypes.oneOf(Object.values(ACTIVITY_VARIANTS)),
  entity: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
};

export default DocsActivityCard;
